import { Dropdown, Menu } from "antd";
import React from "react";
import sort from "../../assets/sort.svg";

function CohortTimeFilter(props) {
  return (
    <div>
      <Dropdown
        overlay={
          <Menu
            style={{ overflow: "auto", minWidth: 150 }}
            items={[
              {
                type: "group",
                label: "Status",
                children: [
                  {
                    key: "1",
                    label: (
                      <span className="pointer text-[#535393] text-[12px] !hover:bg-[#EFEFFE] !rounded-[12px] py-3">
                        Upcoming
                      </span>
                    ),
                  },
                  {
                    key: "2",
                    label: (
                      <span className="pointer text-[#535393] text-[12px] !hover:bg-[#EFEFFE] !rounded-[12px] py-3">
                        Past
                      </span>
                    ),
                  },
                  {
                    key: "3",
                    label: (
                      <span className="pointer text-[#535393] text-[12px] !hover:bg-[#EFEFFE] !rounded-[12px] py-3">
                        Live
                      </span>
                    ),
                  },
                ],
              },
              {
                type: "divider",
              },
              {
                type: "group",
                label: "Date",
                children: [
                  {
                    key: "5",
                    label: (
                      <span className="pointer text-[#535393] text-[12px] !hover:bg-[#EFEFFE] !rounded-[12px] py-3">
                        Newest
                      </span>
                    ),
                  },
                  {
                    key: "6",
                    label: (
                      <span className="pointer text-[#535393] text-[12px] !hover:bg-[#EFEFFE] !rounded-[12px] py-3">
                        Oldest
                      </span>
                    ),
                  },
                ],
              },
            ]}
          />
        }
        placement="bottomRight"
      >
        <button className="border border-[#ECEBF5] w-[30px] h-[30px] rounded-[6px] flex items-center justify-center">
          <img src={sort} alt="" />
        </button>
      </Dropdown>
    </div>
  );
}

export default CohortTimeFilter;
